// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-53b4d4c2]{border:2px solid #000;background-color:#fff;color:#000;padding:14px 32px;font-size:16px;cursor:pointer;color:#fff!important}.success[data-v-53b4d4c2]{border-color:#04aa6d;color:green}.success[data-v-53b4d4c2]:hover{background-color:#04aa6d;color:#fff}", ""]);
// Exports
module.exports = exports;
